import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'timeSince'
})
export class TimeSincePipe implements PipeTransform {

    transform(date1: Date): string {
        const date2 = new Date();
        if (date2 < date1) {
            date2.setDate(date2.getDate() + 1);
        }

        var diff = +date2 - +date1;
        var msec = diff;
        var dd = Math.floor(msec / 1000 / 60 / 60 / 24);
        msec -= dd * 1000 * 60 * 60 * 24;
        var hh = Math.floor(msec / 1000 / 60 / 60);
        msec -= hh * 1000 * 60 * 60;
        var mm = Math.floor(msec / 1000 / 60);
        msec -= mm * 1000 * 60;
        var ss = Math.floor(msec / 1000);
        msec -= ss * 1000;

        let returnString = '';
        if (dd > 0) {
            returnString = dd + ' days';
        } else if (hh > 0) {
            returnString = hh + ' hrs';
        } else if (mm > 0) {
            returnString = mm + ' mins';
        } else if (ss > 0) {
            returnString = ss + ' secs';
        } else return 'Just now';
        return returnString + ' ago';
    }
}
